import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsLoggedGuard } from '../shared/guards/is-logged.guard';
import { IsNotLoggedGuard } from '../shared/guards/is-not-logged.guard';
import { ForgotPasswordComponent } from './shared/components/forgot-password/forgot-password.component';
import { GoToLoginComponent } from './shared/components/go-to-login/go-to-login.component';
import { ResetPasswordComponent } from './shared/components/reset-password/reset-password.component';
import { OnlyOfficeComponent } from './+home/+onlyoffice/only-office/only-office.component';
import { IsExternalGuard } from 'src/shared/guards/is-external.guard';

const routes: Routes = [
  {
    // component: LoginComponent,
    path: 'connexion',
    canActivate: [IsNotLoggedGuard],
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'single-document-request',  
    canActivateChild: [IsLoggedGuard],
    loadChildren: () => import('./single-document-request/single-document-request.module').then(m => m.SingleDocumentRequestModule)
  },
  {
    component: GoToLoginComponent,
    path: 'go-to-login',
    canActivate: [IsNotLoggedGuard]
  },
  {
    component: ForgotPasswordComponent,
    path: 'forgot-password',
    canActivate: [IsNotLoggedGuard]
  },
  {
    component: ResetPasswordComponent,
    path: 'reset-password',
    canActivate: [IsNotLoggedGuard]
  },
  {
    path: 'home',
    canActivateChild: [IsLoggedGuard],
    canActivate: [IsExternalGuard],
    loadChildren: () => import('./+home/home.module').then(m => m.HomeModule)
  },

  {
    component: OnlyOfficeComponent,
    path: 'onlyoffice/:id',

  },
  {
    path: 'consultants',
    loadChildren: () => import('./consultants/consultants.module').then(m => m.ConsultantsModule)
  },
  {
    path: 'public',
    loadChildren: () => import('../app/public/public.module').then(m => m.PublicModule)
  },

  {
    path: '**',
    redirectTo: '/home/tasks'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
